export default "__VITE_ASSET__QodCftz3__"